import { render, staticRenderFns } from "./DateProfit.vue?vue&type=template&id=a5b3e4a8&scoped=true"
import script from "./DateProfit.vue?vue&type=script&lang=js"
export * from "./DateProfit.vue?vue&type=script&lang=js"
import style0 from "./DateProfit.vue?vue&type=style&index=0&id=a5b3e4a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5b3e4a8",
  null
  
)

export default component.exports